var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slideout',{attrs:{"name":"navigation","show":_vm.$root.navigationIsVisble,"show-close":false,"inverse":true},on:{"close":function($event){_vm.$root.navigationIsVisble = false}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }